import React from "react";
import { motion } from "motion/react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK, WHATSAPP_MESSAGE } from "../data/mock";

const WhatsAppFloat = () => {
  const whatsappUrl = `${WHATSAPP_LINK}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[hsl(var(--whatsapp))] text-white px-5 py-3 rounded-full shadow-2xl whatsapp-pulse"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", damping: 15 }}
      whileHover={{ scale: 1.08, boxShadow: "0 20px 40px rgba(37, 211, 102, 0.3)" }}
      whileTap={{ scale: 0.95 }}
    >
      <MessageCircle className="w-6 h-6" />
      <span className="font-medium hidden sm:inline">Fale no WhatsApp</span>
    </motion.a>
  );
};

export default WhatsAppFloat;
